import styled, { css } from "styled-components";

export const Styles = styled.div<{ $compactShell?: boolean }>`
  &.mobile {
    --bg-field: #282828;
    --color-field: #ffffff;
    --color-sub: #f5f5f5;

    --bg-item: #2e302f;
    --color-item: #ffffff;

    --bg-main: #1c1c1c;
    --text-color: #ffffff;

    --text-color-summary: #ffffff;

    --padding-main: 8px;

    padding: var(--padding-main);
    background: var(--bg-main);
    width: 100%;
    max-width: 100vw;
    box-sizing: border-box;

    ${(p) =>
      p.$compactShell
        ? css`
            min-height: 100dvh;
            min-height: 100svh;
          `
        : ""}
  }

  .ant-spin-nested-loading,
  .ant-spin-container {
    width: 100%;
    min-height: inherit;
  }

  --bg-field: #ffffff;

  --bg-item: #fafafa;
  --color-item: #434343;

  --bg-main: #ffffff;
  --text-color: #434343;
  --text-color-summary: #1e3666;

  --padding-main: 24px;

  padding: var(--padding-main);
  background: var(--bg-main);

  color: var(--text-color);
  ${(p) =>
    p.$compactShell
      ? css`
          min-height: 0;
        `
      : css`
          min-height: 100vh;
        `}
`;
